<template>
    <div class="bg-white p-6 shadow-md rounded-lg">
        <h2 class="text-lg font-semibold text-gray-700 mb-4 flex items-center">
            <font-awesome-icon :icon="['fas', 'calendar-alt']" class="text-teal-600 mr-2" />
            Applications by Academic Year
        </h2>
        <div v-if="hasData">
            <apexchart type="bar" height="400" :options="chartOptions" :series="chartSeries" />
        </div>
        <div v-else class="text-gray-500 text-center py-16">
            <div class="text-4xl mb-2">📊</div>
            <div>There is no data to show</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AcademicYearBreakdownChart",
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        hasData() {
            return this.data && this.data.length > 0;
        },
        chartSeries() {
            return [{
                name: 'Applications',
                data: this.data.map(item => item.count)
            }];
        },
        chartOptions() {
            return {
                chart: {
                    type: 'bar',
                    toolbar: { show: false },
                },
                xaxis: {
                    categories: this.data.map(item => this.formatAcademicYear(item.academic_year)),
                    labels: {
                        style: {
                            fontSize: '11px'
                        },
                        rotate: -45
                    }
                },
                colors: ['#14B8A6'],
                plotOptions: {
                    bar: {
                        columnWidth: '10%',
                        distributed: false,
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    style: {
                        fontSize: '12px',
                        fontWeight: 'bold',
                        colors: ['#fff']
                    }
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} Applications`,
                    },
                },
                grid: {
                    borderColor: '#f1f5f9',
                    strokeDashArray: 3,
                },
                yaxis: {
                    title: {
                        text: 'Number of Applications',
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                        }
                    },
                    labels: {
                        style: {
                            fontSize: '11px'
                        }
                    }
                }
            };
        }
    },
    methods: {
        formatAcademicYear(year) {
            // Format academic year for better display
            if (year && year.includes('-')) {
                return year.replace('-', '/');
            }
            return year;
        }
    }
};
</script>